<template>
    <div>
        <header>
            <slot name="header"></slot>
        </header>
        <main>
            <h1 v-for="item in news">这是我的子组件{{item.username}}</h1>
            <slot>
                只有在没有要分发的内容时才会显示。
            </slot>
        </main>
        <footer>
            <slot name="footer"></slot>
        </footer>


    </div>
</template>
        <script>
            export default{
                name: "sendmessage",
                        props:{
                    news:{
                        type: Array
                    }


                },
                methods: {
                    dosomething: function (){
                        alert("good")
                    }
                }
            }
        </script>


// WEBPACK FOOTER //
// src/components/SendMessage.vue